export default "__VITE_ASSET__4f6fdd60__"